module.exports = __webpack_public_path__ + "static/media/whocanuse3.df1a04dc.PNG";